import Vue from 'vue'
import _ from 'underscore'

export default {

	namespaced: true,

	state: {

		data: {}

	},

	getters: {

		all: function(state) {

			return state.data

		},

		public: function(state) {

			return state.data.public || false

		},

		summary: function(state) {

			return state.data.summary || {}

		},

		candidates: function(state) {

			return state.data.candidates || []

		},

		peers: function(state) {

			return state.data.peers || []

		},

		levels: function(state) {

			return state.data.levels || []

		},

		games: function(state) {

			return state.data.games || []

		},

		overview: function(state) {

			return state.data.overview || {}

		},

		weights: function(state) {

			return state.data.weights || {}

		},

		durations: function(state) {

			return state.data.durations || {}

		},

		counts: function(state) {

			return state.data.counts || {}

		},

		publishers: function(state) {

			return state.data.publishers || []

		},

		designers: function(state) {

			return state.data.designers || []

		},

		types: function(state) {

			return state.data.types || []

		},

		ratings: function(state) {

			return state.data.ratings || []

		},

		concentration: function(state) {

			return state.data.concentration || {}

		},

		bias: function(state) {

			return state.data.bias || {}

		},

		efficiency: function(state) {

			return state.data.efficiency || {}

		},

		coverage: function(state) {

			return state.data.coverage || {}

		},

		share: function(state) {

			return state.data.share || {}

		},

		size: function(state) {

			return state.data.size || {}

		},

		plays: function(state) {

			return state.data.plays || {}

		},

		indexes: function(state) {

			return state.data.indexes || {}

		}

	},

	mutations: {

		reset: function(state) {

			state.data = {}

		},

		'indexes/index': function(state, data) {

			_.each(state.data.indexes.indexes, function(value, index) {

				if(value.id === data.id) {

					Vue.set(state.data.indexes.indexes, index, data)

				}

			})

		},

		'indexes/tracking': function(state, data) {

			Vue.set(state.data.indexes, 'tracking', data)

		},

		set: function(state, data) {

			_.each(data, function(value, key) {

				Vue.set(state.data, key, value)

			})

		}

	},

	actions: {}

}